module.exports = __webpack_public_path__ + "img/Mirana.c56ceee8.png";